import React, { useState, useCallback } from 'react';
import { GenericListPage } from '../../components/generic';
import { useSupportAgreements, SupportAgreement } from './useData';
import { moduleConfig, getColumns, getToolbarIcon, getTableActions } from './config';
import SupportAgreementRenewalRemindersPanel from './SupportAgreementRenewalRemindersPanel';

const List: React.FC = () => {
  const [remindersPanelOpen, setRemindersPanelOpen] = useState(false);
  const [selectedAgreement, setSelectedAgreement] = useState<SupportAgreement | null>(null);
  const { mutate } = useSupportAgreements();

  const openRenewalRemindersPanel = useCallback((agreement: SupportAgreement) => {
    setSelectedAgreement(agreement);
    setRemindersPanelOpen(true);
  }, []);

  const closeRenewalRemindersPanel = useCallback(() => {
    setRemindersPanelOpen(false);
    setSelectedAgreement(null);
  }, []);

  return (
    <div className="flex flex-col h-full min-h-0">
      <div className="flex-1 min-h-0 overflow-hidden">
        <GenericListPage<SupportAgreement>
          useData={useSupportAgreements}
          listContext={{ onOpenRenewalRemindersPanel: openRenewalRemindersPanel }}
          config={{
            ...moduleConfig,
            getColumns: (formatDate, formatCurrency, colors, listContext) =>
              getColumns(formatDate, formatCurrency ?? moduleConfig.utils.formatCurrency, colors, listContext),
            getToolbarIcon,
            getTableActions,
          }}
        />
      </div>
      <SupportAgreementRenewalRemindersPanel
        open={remindersPanelOpen}
        onClose={closeRenewalRemindersPanel}
        agreement={selectedAgreement}
        onReminderAdded={mutate}
        variant="modal"
      />
    </div>
  );
};

export default List;

